"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubpagesContainerProperty = exports.subpagesContainerPropertyDefinition = void 0;
exports.subpagesContainerPropertyDefinition = {
    name: 'subpages-container',
    type: 'container',
    constraints: [
        {
            name: 'properties',
            argument: ['subpage'],
        },
    ],
    multiple: true,
    view: { label: 'Subpages' },
};
const isSubpagesContainerProperty = (prop) => {
    return prop.name === exports.subpagesContainerPropertyDefinition.name;
};
exports.isSubpagesContainerProperty = isSubpagesContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VicGFnZXMtY29udGFpbmVyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc3VicGFnZXMtY29udGFpbmVyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFLG9CQUFvQjtJQUMxQixJQUFJLEVBQUUsV0FBVztJQUNqQixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLFNBQVMsQ0FBQztTQUN0QjtLQUNGO0lBQ0QsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsVUFBVSxFQUFFO0NBQ0ksQ0FBQTtBQUkxQixNQUFNLDJCQUEyQixHQUFHLENBQUMsSUFBa0IsRUFBcUMsRUFBRTtJQUNuRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9